// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l6Ner7C7O5I4V69HVVgW {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 2vmin;
  margin: 3vmin 0;
  padding: 3vmin;
  overflow-y: scroll;
  height: 90%;
  width: 95%;
}

.l6Ner7C7O5I4V69HVVgW .zqVYKU3SzotKremHzxQ_ {
  color: var(--text-light);
  font-size: 2vmin;
  position: absolute;
  top: 50vh;
}`, "",{"version":3,"sources":["webpack://./src/components/OrderList/OrderList.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AACJ;;AAEA;EACI,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AACJ","sourcesContent":[".OrderList {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-radius: 2vmin;\n    margin: 3vmin 0;\n    padding: 3vmin;\n    overflow-y: scroll;\n    height: 90%;\n    width: 95%;\n}\n\n.OrderList .noOrders {\n    color: var(--text-light);\n    font-size: 2vmin;\n    position: absolute;\n    top: calc(50vh);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"OrderList": `l6Ner7C7O5I4V69HVVgW`,
	"noOrders": `zqVYKU3SzotKremHzxQ_`
};
export default ___CSS_LOADER_EXPORT___;
